// extracted by mini-css-extract-plugin
export default {"main":"widget_main__OLqHI","header":"widget_header__d-Pyw","body":"widget_body__M32wt","extra":"widget_extra__8qEkm"};